import React from 'react';
import RedistributionImportEditor from './RedistributionImportEditor';
import { useGetCalculationRedistributionImportQuery } from '../../../apiCalculationRedistributionImport';
import { useTemplateOrCalculation } from '../../../../../../../../hooks/useTemplateOrCalculation';
import LoadingIndicator from '../../../../../../../../components/global/LoadingIndicator/LoadingIndicator';
import RedistributionPendingImport from './RedistributionPendingImport';

const RedistributionImportStepImport: React.FC = () => {
  const calculation = useTemplateOrCalculation();
  const { data, isFetching, isError } = useGetCalculationRedistributionImportQuery(calculation.id);

  const showEditor = !isFetching && isError;

  if (isFetching) {
    return <LoadingIndicator />;
  }

  if (showEditor) {
    return <RedistributionImportEditor />;
  } else {
    return data && <RedistributionPendingImport calculationImport={data} />;
  }
};

export default RedistributionImportStepImport;
